<template>
  <v-overlay v-if="step === null" :value="true">
    <v-progress-circular
        indeterminate
        size="30"
    />
  </v-overlay>
  <v-main v-else-if="step === 12">
    <AppBar :back="customBack"/>
    <SurveyResult @bottomSheetOpen="bottomSheetOpen"
                  :travelApplNo="travelApplNo"
                  :unitNo="unitNo"
                  :travelApplStepCd="travelApplStepCd"
                  :memberStepApplCnt="memberStepApplCnt"
                  :memberNo="memberNo"
                  :isTravelMap="isTravelMap"
                  :isSuitcase="isSuitcase"
                  :isMyTree="isMyTree"/>
    <SurveyBottomSheet :sheet="sheet" :height="'75vh'" :flag="sheetFlag" @sheetClose="sheetClose"
                       ref="SurveyBottomSheet"/>
  </v-main>
  <SurveyIntro v-else-if="step === 0" :step="step" @surveyStart="surveyStart" @surveyStop="surveyStop"
               @setTimeoutId="setTimeoutId"/>
  <v-main v-else>
    <AppBar :hide-back="step === 11" :title="title" :hide-background="step === 0" extension-height="2px">
      <v-progress-linear v-if="step !== 12 && step != 0 && step !== 11" absolute height="2" background-color="#D6D6D6"
                         :value="progress" bottom/>
    </AppBar>
    <SurveyType01 v-if="step === 1" :question="questionStr[current].ques"
                  :surveyData="questionStr[current]"
                  :travelApplStepCd="travelApplStepCd"
                  :memberStepApplCnt="memberStepApplCnt"
                  :answer="answer" @radioChanged="radioChanged"/>
    <SurveyType02 v-else-if="step === 2" @emotionSelected="emotionSelected"
                  :surveyData="questionStr[current]"
                  :travelApplStepCd="travelApplStepCd"
                  :memberStepApplCnt="memberStepApplCnt"/>
    <SurveyType03 v-else-if="step === 3"
                  :surveyData="questionStr[current]"
                  :travelApplStepCd="travelApplStepCd"
                  :memberStepApplCnt="memberStepApplCnt"
                  :beforeSurveyData="questionStr[current-1]"
                  :answer="answer" @emotionSelected="emotionSelected"/>
    <SurveyType04 v-else-if="step === 4" :question="questionStr[current].ques"
                  :surveyData="questionStr[current]"
                  :travelApplStepCd="travelApplStepCd"
                  :memberStepApplCnt="memberStepApplCnt"
                  :answer="answer" @radioChanged="radioChanged"/>
    <SurveyType05 v-else-if="step === 5"
                  :surveyData="questionStr[current]"
                  :travelApplStepCd="travelApplStepCd"
                  :memberStepApplCnt="memberStepApplCnt"
                  ref="iFrameObg" @radioChanged="radioChanged" @disabledNextStatus="disabledNextStatus"/>
    <SurveyType06 v-else-if="step === 6" :question="questionStr[current].ques"
                  :surveyData="questionStr[current]"
                  :travelApplStepCd="travelApplStepCd"
                  :memberStepApplCnt="memberStepApplCnt" @emotionSelected="emotionSelected"/>
    <SurveyType07 v-else-if="step === 7" :question="questionStr[current].ques"
                  :surveyData="questionStr[current]"
                  :travelApplStepCd="travelApplStepCd"
                  :memberStepApplCnt="memberStepApplCnt" @emotionSelected="emotionSelected"/>
    <SurveyType08 v-else-if="step === 8" :question="questionStr[current].ques"
                  :surveyData="questionStr[current]"
                  :travelApplStepCd="travelApplStepCd"
                  :memberStepApplCnt="memberStepApplCnt" @emotionSelected="emotionSelected"/>
    <SurveyType09 v-else-if="step === 9" :question="questionStr[current].ques"
                  :surveyData="questionStr[current]"
                  :travelApplStepCd="travelApplStepCd"
                  :memberStepApplCnt="memberStepApplCnt" @emotionSelected="emotionSelected"/>
    <SurveyType10 v-else-if="step === 10" :question="questionStr[current].ques"
                  :surveyData="questionStr[current]"
                  :travelApplStepCd="travelApplStepCd"
                  :memberStepApplCnt="memberStepApplCnt"
                  @emotionSelected="emotionSelected" @step10Selected="step10Selected" ref="SurveyType10"/>
    <SurveyAnalysing v-else-if="step === 11" @result="result"
                     :travelApplNo="travelApplNo"
                     :unitNo="unitNo"
                     :travelApplStepCd="travelApplStepCd"
                     :memberStepApplCnt="memberStepApplCnt"
                     :memberNo="memberNo"/>
    <!-- <FooterBtnsNext v-if="step !== 0 && step !== 11" @before="before" @next="next" :current="current" :total="total" :disabledNext="disabledNext"/> -->

    <v-footer app fixed color="white" class="content-footer">
      <FooterBtnsNext v-if="current != 0 && step !== 0 && step !== 11" @before="before" @next="next" :current="current"
                      :total="total" :disabledNext="disabledNext"/>
      <FooterBtns v-if="step == 1 && current == 0" :survey="'다음'" :disabledNext="disabledNext" @next="next"/>
    </v-footer>
  </v-main>
</template>

<script>
import store from '@/store'
import SurveyIntro from './SurveyIntro'
import SurveyType01 from './SurveyType01' /* 1~14 */
import SurveyType02 from './SurveyType02' /* 15 */
import SurveyType03 from './SurveyType03' /* 16 */
import SurveyType04 from './SurveyType04' /* 17 ~ 38 */
import SurveyType05 from './SurveyType05' /* 39 */
import SurveyType06 from './SurveyType06' /* 40 */
import SurveyType07 from './SurveyType07' /* 41 */
import SurveyType08 from './SurveyType08' /* 42,43 */
import SurveyType09 from './SurveyType09' /* 44 */
import SurveyType10 from './SurveyType10' /* 45 */
import SurveyAnalysing from './SurveyAnalysing'
import SurveyResult from './SurveyResult'
import FooterBtns from "@/components/btns/FooterBtns"
import FooterBtnsNext from '@/components/btns/FooterBtnsNext'
// import ProgressLinear from '@/components/progress/ProgressLinear'
import SurveyBottomSheet from "@/components/layout/bottomSheet/SurveyBottomSheet"

export default {
  components: {
    SurveyIntro,
    SurveyType01,
    SurveyType02,
    SurveyType03,
    SurveyType04,
    SurveyType05,
    SurveyType06,
    SurveyType07,
    SurveyType08,
    SurveyType09,
    SurveyType10,
    SurveyAnalysing,
    SurveyResult,
    FooterBtns,
    FooterBtnsNext,
    // ProgressLinear,
    SurveyBottomSheet
  },
  data: () => ({
    step: null,
    total: 45,
    current: 0,
    progress: 0,
    answer: 0,
    disabledNext: true,
    questionStr: [],
    answerValue: [],
    sheet: false,
    sheetFlag: 0,
    travelApplNo: 1,
    memberNo: 0,
    replyYn: '',
    unitNo: 1,
    travelApplStepCd: '',
    memberStepApplCnt: 0,
    pageCnt: 0,
    progressQuesNo: 1,
    unitDtlQuesNo: 0,
    unitDtlNo: 0,
    startNumberByType: [],
    isGameNext: false,
    isSelNext: false,
    score: 0,
    insertType: '',
    startType: '',
    isTravelMap: false,
    isSuitcase: false,
    isMyTree: false,
    timeoutId: [],
  }),
  computed: {
    title() {
      // intro
      if (this.step === 0) return '여행지원서'
      return null
    }
  },
  watch: {
    // step(){
    //     if(this.step ==0){
    //         this.$root.$children[0].$refs.appBar.$el.style.display='none'
    //     }else{
    //         this.$root.$children[0].$refs.appBar.$el.style.display='block'
    //     }
    // }
  },
  created() {
    this.travelApplStepCd = this.$route.query.travelApplStepCd;
    this.startType = this.$route.query.startType;
    if (this.$route.query.isTravelMap != undefined) {
      this.isTravelMap = this.$route.query.isTravelMap
    }
    if (this.$route.query.isSuitcase != undefined) {
      this.isSuitcase = this.$route.query.isSuitcase
    }
    if (this.$route.query.isMyTree != undefined) {
      this.isMyTree = this.$route.query.isMyTree
    }

    this.current = 0;
    this.memberNo = this.$store.state.auth.authUser.userKey;

    this.getMemberStepCnt()
    // setTimeout(() => this.getMemberStepCnt(),  100);
  },
  mounted() {
    // this.step = 0;
  },
  methods: {
    customBack() {
      if (this.$route.query.isTravelMap) {
        this.$router.push({name: '여행지도', params: {beforeOrdDtlNo: this.$route.query.ordDtlNo}})
      } else {
        this.prevPage()
      }
    },
    surveyStart() {
      this.step = 1;
    },
    surveyStop() {
      if (this.isSuitcase) {
        this.$router.push({name: "여행가방"});
      } else {
        this.movePage('/');
      }
      // this.movePage('/user');
    },
    setTimeoutId(val) {
      this.timeoutId = val
    },
    before() {
      if (this.current > 0) {
        if (this.step === 5 && this.isGameNext === true) {  // 게임에서 뒤로가기
          this.$refs.iFrameObg.goGame();
          this.isGameNext = false;

          this.current -= 1;
          // this.getStepLoadData();
          this.progressValue();
          this.answer = this.answerValue[this.current];
          this.disabledNext = false;
          this.isSelNext = false;

          if ((Number(this.current + 1) === Number(this.startNumberByType[this.step - 1].unitDtlPageSeq))) {
            /* 이전 step으로 */
            this.step = this.startNumberByType[this.step - 2].proc;   // step은 화면에서 1로 시작 / db 에서 [0]번째 이므로 뒤로가기시 -1이 아닌 -2를 해야 한다
          }

        } else if (this.step === 10 && this.$refs.SurveyType10.viewStep() === 2) {

          this.answer = this.answerValue[this.current];
          this.disabledNext = true;
          this.$refs.SurveyType10.getStepLoadData('P');
        } else {
          this.current -= 1;
          // this.getStepLoadData();
          this.progressValue();
          this.answer = this.answerValue[this.current];
          this.disabledNext = false;
          this.isSelNext = false;

          if ((Number(this.current + 1) === Number(this.startNumberByType[this.step - 1].unitDtlPageSeq))) {
            /* 이전 step으로 */
            this.step = this.startNumberByType[this.step - 2].proc;   // step은 화면에서 1로 시작 / db 에서 [0]번째 이므로 뒤로가기시 -1이 아닌 -2를 해야 한다
          }
        }

      }
    },
    next() {
      if (this.current < this.total) {

        this.disabledNext = true

        if (this.step === 5 && this.isGameNext === false) {
          this.$refs.iFrameObg.goGame();      // 게임 skip시 주석 처리
          this.isSelNext = false;
          this.isGameNext = true;

          // 임시 (게임 skip)
          // this.step = this.startNumberByType[5].proc;

          this.current += 1;
          // 게임 사용시
          this.step = this.startNumberByType[4].proc;

          this.getTravelReplyNoForUnikey();

          this.disabledNext = true

        } else if (this.step === 5 && this.isGameNext === true) {   // 게임 사용시
          this.step = this.startNumberByType[5].proc;
          this.isGameNext = false;
          this.getTravelReplyNoForUnikey();
        } else if (this.step === 10 && this.$refs.SurveyType10.viewStep() === 1) {
          this.isGameNext = false;
          // this.disabledNext = true;
          this.$refs.SurveyType10.change(this.answer);
        } else {
          this.answerValue[this.current] = this.answer; // 저장

          if (this.step === 2 || this.step === 3 || this.step === 6 || this.step === 7 || this.step === 8 || this.step === 9 || this.step === 10) {
            this.answerValue[this.current] = this.questionStr[this.current].unitDtlReplyNo
          }
          if (this.isGameNext != true) {
            this.setTravelReplyRegist(this.current);
          } else {
            // 게임 다음버튼은 기존 로직 그대로

            this.isGameNext = false;
            // this.getStepLoadData();
            this.current += 1;
            this.progressValue()
            if (this.answerValue[this.current] === undefined) {
              this.answer = 0;
              // this.disabledNext = true;
            } else {
              this.answer = this.answerValue[this.current];
            }

            /* 다음 step으로 */

            if (this.current === 45 && this.$refs.SurveyType10.viewStep() === 2) {
              this.step = 11;
            } else if (this.current === Number(this.startNumberByType[this.step].unitDtlPageSeq)) {
              setTimeout(() => this.step = this.startNumberByType[this.step].proc, 500); // 저장보다 호출 속도가 빨라 delay줌
            }
          }
        }
      }


    },
    progressValue() {
      this.progress = (100 / this.total) * this.current;
    },
    radioChanged(value,next) {    // radio change event
      if (value != null) {
        this.disabledNext = false;
        this.answer = value;
        this.reply = value;
        this.insertType = '';
        this.replyYn = 'Y';
        if(next){
          this.next()
        }
      }
    },
    emotionSelected(value) {    // emotion choice event
      if (this.questionStr[this.current].unitDtlReplyNo == 0 || this.questionStr[this.current].unitDtlReplyNo == undefined) {
        this.getTravelReplyNoForUnikey();
      }

      // if (this.step === 2 || this.step === 3 || this.step === 10) {   // 감정선택, 감정온도계, 10번유형
      if (this.step === 3) {  // 온도계 점수 필수값 처리
        if (value.length === 3) {
          var disabled = 0
          value.forEach((val) => {
            var words = val.split('-')
            if (words[1] <= 0) {
              disabled += 1
            }
          })

          if (disabled == 0) {
            this.disabledNext = false;
          } else {
            this.disabledNext = true;
          }

          this.reply = value.join('|');
        } else {
          this.disabledNext = true;
        }
      } else if (this.step === 2 || this.step === 10) {   // 감정선택, 감정온도계, 10번유형
        if (value.length === 3) {
          this.disabledNext = false;
          this.reply = value.join('|');
        } else {
          this.disabledNext = true;
        }
      } else if (this.step === 9) {   // 예/아니오 문항
        if (value.length === 2) {
          this.disabledNext = false;
          this.reply = value.join('|');
        }
      } else {    // 일반 text 입력 시
        if (value == null || value.trim() == "" || value.length > 500) {
          this.disabledNext = true
        } else {
          this.disabledNext = false
        }
        // this.disabledNext = false;
        this.reply = value;
      }

      this.insertType = 'T'
      this.answer = value;
      this.replyYn = 'Y';
    },
    step10Selected(value) {
      if (value[3] == null || value[3].trim() == "" || value[3].length > 500) {
        this.disabledNext = true
      } else {
        this.disabledNext = false
      }

      if (this.questionStr[this.current].unitDtlReplyNo == 0 || this.questionStr[this.current].unitDtlReplyNo == undefined) {
        this.getTravelReplyNoForUnikey();
      }

      // this.disabledNext = false;
      this.reply = value.join('|');
      this.insertType = 'T'
      this.answer = value;
      this.replyYn = 'Y';
    },
    result() {
      this.step = 12;
    },
    bottomSheetOpen(flag, areaCritValue) {
      /* bottom sheet */
      this.sheetFlag = flag;
      this.sheet = true;
      if (flag != 0) {
        this.$refs.SurveyBottomSheet.setSheetData(areaCritValue, flag);
      }
      // 가이드 피드백 화면 닫기/피드백 버튼 dim 처리 된것 처럼 보이게 하기
      let items = parent[0].parent.document.body.querySelectorAll('.brightness-target')
      for (let i = 0; i < items.length; i++) {
        items[i].classList.add('brightness')
      }
    },
    sheetClose() {
      this.sheet = false;
      // 가이드 피드백 화면 닫기/피드백 버튼 dim 처리 된것 처럼 보이게 하기
      let items = parent[0].parent.document.body.querySelectorAll('.brightness-target')
      for (let i = 0; i < items.length; i++) {
        items[i].classList.remove('brightness')
      }
    },
    // 해당 ordDtlNo::  중간검사 or 사후검사 이력이 없을경우, 사전검사의 stepCnt를 찾아서 넣어줌
    async getMemberStepCntAfter () {
      let param = [
                    {'travelApplNo': this.travelApplNo},
                    {'memberNo': this.memberNo},
                    {'travelApplStepCd': '0001'},
                    {'ordDtlNo': this.$route.query.ordDtlNo}
                  ]
     await store.dispatch('getMemberStepCnt', this.$_payload('so', param))
          .then(res => {
            if (res.success) {
              this.memberStepApplCnt = res.data;
            }
          }).finally(()=>{
        this.getTravelQuesList(this.travelApplNo);
      })
    },
    async getMemberStepCnt() {
      // let ordDtlNo = 0
      // if (this.$route.query.ordDtlNo !== undefined) {
      //   ordDtlNo = Number(this.$route.query.ordDtlNo)
      // }
      let param = [
            {'travelApplNo': this.travelApplNo},
            {'memberNo': this.memberNo},
            {'travelApplStepCd': this.travelApplStepCd},
            {'ordDtlNo': this.$route.query.ordDtlNo}
          ]
      await store.dispatch('getMemberStepCnt', this.$_payload('so', param))
          .then(res => {
            if (res.success) {

              if (res.data == 0 || res.data == null) {
                this.step = 0
                if (this.travelApplStepCd === '0002' || this.travelApplStepCd === '0003') {
                // 해당 ordDtlNo::  중간검사 or 사후검사 이력이 없을경우, 사전검사의 stepCnt를 찾아서 넣어줌
                  this.getMemberStepCntAfter()
                } else {
                  this.memberStepApplCnt = 1;
                  this.getTravelQuesList(this.travelApplNo);
                }
              } else {
                let getStepCnt = res.data;
                if (this.startType == 'R') {
                  this.step = 0
                  getStepCnt = getStepCnt + 1;
                }
                this.memberStepApplCnt = getStepCnt;
                this.getTravelQuesList(this.travelApplNo);
              }
            } else {
              this.memberStepApplCnt = 0;
            }
          })
          .catch(error => {
            console.error(error)
            this.memberStepApplCnt = 0;
          })
          .finally(() => {
          })
    },
    async getTravelQuesList(travelApplNo) { // 질문 리스트를 가져옴.
      await store.dispatch('getTravelQuesList', this.$_payload('so', [{'travelApplNo': travelApplNo}]))
          .then(res => {
            if (res.success) {
              this.questionStr = res.data;
              this.getStartNumberByTypeList(travelApplNo)
              this.getProgressStep();
            } else {
              console.log(res.msg)
              this.questionStr = ''
            }
          })
          .catch(error => {
            console.error(error)
            this.questionStr = ''
          })
          .finally(() => {
          })
    },
    async getStartNumberByTypeList(travelApplNo) {  // 스텝별 시작 번호 조회
      await store.dispatch('getStartNumberByTypeList', this.$_payload('so', [{'travelApplNo': travelApplNo}, {'unitNo': this.unitNo}]))
          .then(res => {
            if (res.success) {
              this.startNumberByType = res.data;
            } else {
              console.log(res.msg)
              this.pageCnt = 0;
              this.step = 0;
            }
          })
          .catch(error => {
            console.error(error)
            this.pageCnt = 0;
            this.step = 0;
          })
          .finally(() => {
          })
    },
    async getProgressStep() {
      await store.dispatch('getProgressStep', this.$_payload('so', [
        {'travelApplNo': this.travelApplNo},
        {'unitNo': this.unitNo},
        {'memberNo': this.memberNo},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
          .then(res => {
            if (res.success) {
              if (res.data != null) {
                if (10 === res.data.unitDtlSeq && this.startType !== 'RR') {
                  this.step = 12;
                } else if(10 == res.data.unitDtlSeq  && this.startType == 'RR'){
                  this.step = 0
                  this.memberStepApplCnt = this.memberStepApplCnt + 1;

                } else if(10 !== res.data.unitDtlSeq  && this.memberStepApplCnt > 1){

                  if (this.travelApplStepCd === '0002' || this.travelApplStepCd === '0003') {
                    this.$router.replace({name: "travelIntro", query: {travelApplStepCd: this.travelApplStepCd, startType: 'RR'}});
                  }
                  if (this.startType == 'RR') {
                    this.pageCnt = res.data.pageCnt;
                    this.step = res.data.unitDtlSeq;
                    this.current = res.data.unitDtlPageSeq
                    this.unitDtlNo = res.data.unitDtlNo;
                    this.unitDtlQuesNo = res.data.unitDtlQuesNo;

                    // this.getStepLoadData();
                    //this.getTravelReplyNoForUnikey();

                    this.progressValue()

                  }else{
                    this.memberStepApplCnt = this.memberStepApplCnt-1
                    this.step = 12;
                  }

                }else {
                  this.pageCnt = res.data.pageCnt;
                  this.step = res.data.unitDtlSeq;
                  this.current = res.data.unitDtlPageSeq
                  this.unitDtlNo = res.data.unitDtlNo;
                  this.unitDtlQuesNo = res.data.unitDtlQuesNo;

                  // this.getStepLoadData();
                  //this.getTravelReplyNoForUnikey();

                  this.progressValue()
                }
              }
            } else {
              console.log(res.msg)
              this.pageCnt = 0;
              this.step = 0;
            }
          })
          .catch(error => {
            console.error(error)
            this.pageCnt = 0;
            this.step = 0;
          })
          .finally(() => {
          })
    },
    async getStepLoadData() {
      await store.dispatch('getStepLoadData', this.$_payload('so', [
        {'travelApplNo': this.travelApplNo},
        {'unitNo': this.questionStr[this.current].unitNo},
        {'unitDtlNo': this.questionStr[this.current].unitDtlNo},
        {'unitDtlQuesNo': this.questionStr[this.current].unitDtlQuesNo},
        {'unitDtlPageSeq': this.current},
        {'memberNo': this.memberNo},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
          .then(res => {
            if (res.success) {
              this.answer = res.data.unitDtlReplyNo;
              if (this.step === 1 || this.step === 4) {
                this.radioChanged(this.answer);
              } else if (this.step === 2 || this.step === 3 || this.step === 9 || this.step === 10) {
                let arrReply = [];
                if (res.data.reply != undefined && res.data.reply != null) {
                  arrReply = res.data.reply.split('|');
                }

                this.emotionSelected(arrReply);
                this.reply = arrReply;
              } else {
                this.emotionSelected(res.data.reply);
              }
            } else {
              console.log(res.msg)
              this.answer = 0;
            }
          })
          .catch(error => {
            console.error(error)
            this.answer = 0;
          })
          .finally(() => {
          })
    },
    async setTravelReplyRegist(current) { // 다음 버튼 클릭 시 현재 값을 저장함.
      const params = {
        memberNo: this.memberNo,
        unitDtlReplyNo: this.answerValue[current],
        unitDtlQuesNo: this.questionStr[current].unitDtlQuesNo,
        unitNo: this.questionStr[current].unitNo,
        unitDtlNo: this.questionStr[current].unitDtlNo,
        travelApplNo: this.questionStr[current].travelApplNo,
        travelApplStepCd: this.travelApplStepCd,
        memberStepApplCnt: this.memberStepApplCnt,
        reply: this.reply,
        replyYn: this.replyYn,
        score: this.score,
        insertType: this.insertType
      }
      await store.dispatch('setTravelReplyRegist', this.$_payload('ba', params))
          .then(res => {
            if (res.success) {
              // 기존 저장이후 작업 start
              this.isGameNext = false;
              // this.getStepLoadData();
              this.current += 1;
              this.progressValue()
              if (this.answerValue[this.current] === undefined) {
                this.answer = 0;
                this.disabledNext = true;
              } else {
                this.answer = this.answerValue[this.current];
              }

              /* 다음 step으로 */

              if (this.current === 45 && this.$refs.SurveyType10.viewStep() === 2) {
                this.step = 11;
              } else if (this.current === Number(this.startNumberByType[this.step].unitDtlPageSeq)) {
                this.step = this.startNumberByType[this.step].proc
              }

              // 기존 저장이후 작업 end

            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
    },
    async getTravelReplyNoForUnikey() {
      await store.dispatch('getTravelReplyNoForUnikey', this.$_payload('so', [
        {'travelApplNo': this.questionStr[this.current].travelApplNo},
        {'unitDtlQuesNo': this.questionStr[this.current].unitDtlQuesNo},
        {'unitDtlNo': this.questionStr[this.current].unitDtlNo},
        {'unitNo': this.questionStr[this.current].unitNo}
      ]))
          .then(res => {
            if (res.success) {
              this.questionStr[this.current].unitDtlReplyNo = res.data;
            } else {
              console.log(res.msg)
              this.questionStr[this.current].unitDtlReplyNo = ''
            }
          })
          .catch(error => {
            console.error(error)
            this.questionStr[this.current].unitDtlReplyNo = ''
          })
          .finally(() => {
          })
    },
    disabledNextStatus(){
      this.disabledNext = !this.disabledNext
    }
  },
  beforeRouteLeave(to, from, next) {
    this.timeoutId.forEach((val) => {
      clearTimeout(val)
    })

    next()
  }
}
</script>

<style lang="scss" scoped>
::v-deep.v-item-group.v-bottom-navigation .v-btn {
  max-width: 100%;
}
.survey-container {
  position: relative;
  //padding-bottom: 80px; /* 하단 버튼영역 밑으로 내려가는 스크롤 영역*/
}
</style>
